import axios from 'axios'
import { DATAMASTER_ENDPOINT } from 'cfgCommon/endpoints'

export const getSpecsAndRelevantAttributes = async (datamaster_id) => {
    const specsAndAttributes = await axios.all([
        axios.get(`${DATAMASTER_ENDPOINT}/${datamaster_id}`),
        axios.get(`${DATAMASTER_ENDPOINT}/attributesBySegment`)
    ])

    const specs = specsAndAttributes[0].data?.data
    const attributes = specsAndAttributes[1].data?.data

    const att = attributes?.filter(attr => attr.segment === specs.SEGMENTO)?.[0]
    if (att) {
        const attributesBySegment = att.attributes.split(',')
        return { ...specs, attributesBySegment }
    }

    return { ...specs }
}
